<template>
  <div class="main">
    <div class="header">
      <div class="back-icon">
        <img
          class="back-img"
          src="~/assets/imgs/backiconwhite.png"
          alt=""
          @click="navManager.back()"
        />
      </div>
      <div class="header-title">
        <div class="title">福利商品</div>
      </div>
      <div class="user">
        <img v-if="user.icon" :src="user.icon" />
        <img v-else src="~/assets/imgs/sculpture.png" />
        <div>
          <div class="user-name">{{ user.name || "你未登录" }}</div>
          <div class="user-desc">{{ memberDesc || "你还不是VIP会员" }}</div>
          <div class="user-balance">乐币：{{ lecoinBalance }}</div>
        </div>
      </div>
    </div>
    <div class="member-box">
      <div class="member-header" v-if="isMember">
        <div>
          <img src="~/assets/imgs/mine_member.png" alt="" />
          <span>{{ memberDesc }}</span>
        </div>
        <div class="btn" @click="goMember">会员中心</div>
      </div>
      <div class="member-header" v-else>
        <div>
          <img src="~/assets/imgs/mine_member.png" alt="" />
          <span>免广告 / 送礼包 / 去弹窗</span>
        </div>
        <div class="btn" @click="goMember">会员充值</div>
      </div>
      <div class="member-footer">
        <div class="member-footer-item" @click="goBag">
          <img src="~/assets/imgs/mine_bag.png" alt="" />
          <span>我的礼包</span>
        </div>
        <div style="height: 100%; width: 1px; background: #efeeee"></div>
        <div class="member-footer-item" @click="goCoupon">
          <img src="~/assets/imgs/mine_coupon.png" alt="" />
          <span>我的优惠券</span>
        </div>
      </div>
    </div>
    <div class="exchange-list" @click="isShowOrderList = true">
      <div class="left">
        <img src="~/assets/imgs/exchange_record.png" alt="" />
        <span>兑换记录</span>
      </div>
      <img src="~/assets/imgs/right.png" alt="" />
    </div>
  </div>
  <OrderList v-if="isShowOrderList" @close="isShowOrderList = false"></OrderList>
  <Goodsfoot :pageId="2"/>
</template>
<script lang="ts" setup>
import { getLecionBalance ,sureMember,getPageCenter} from "~/business/alova/methods/goodsPageApi.ts";
import { useRequest } from "alova";
import { bpV2, getUserInfoVal } from "~/utils/jsb";
import { pandora } from "~/utils/index";
import sdkorlyjump from "~/utils/sdkorlyjump";
import { couponBaseUrl, giftBaseUrl, memberBaseUrl } from "~/business/axios/url";

import OrderList from "../../views/goodsmain/orderList.vue";
import Goodsfoot from "../../views/goodsfoot";

const isShowOrderList = ref(false);
const isMember = ref(false);
const memberDesc = ref("");
const lecoinBalance = ref(0);
const user = ref({});

/**
 * @description 我的会员
 * @return {void}
 */
const goMember = async () => {
  pandora("event_goods_shop_mine_member_btnclick", "福利商店我的页面：会员按钮点击", {
    status: isMember.value,
    isintermodalenv: isEnvModal()
  });
  const res = await getPageCenter({ codeList: [55] });
  sdkorlyjump("", res?.data[0]?.url);
};
/**
 * @description 我的礼包页面跳转
 * @return {void}
 */
const goBag = async () => {
  const res = await getPageCenter({ codeList: [53] });
  sdkorlyjump("", res?.data[0]?.url);
};
/**
 * @description 我的优惠券页面跳转
 * @return {void}
 */
const goCoupon = async () => {
  const res = await getPageCenter({ codeList: [76] });
  sdkorlyjump("", res?.data[0]?.url);
};
onMounted(async () => {
  if(window && window.navigator.userAgent.includes("meta-pay-sdk")){
    jsb?.execSync("setNativeTitleShow", false);
  }
  const baseParams = await bpV2();
  const paramsObj = {
    Authorization:
      "eyJhbGciOiJIUzI1NiJ9.eyJqdGkiOiIwYjc4Y2NiNi1lMzdmLTRlNDctYWQ5Ni1hNjU2ZWMwNzVmMjkiLCJpYXQiOjE2MjQ0NTUzMjgsInN1YiI6IntcInV1aWRcIjpcIjZjNzE5YWQyM2YxYTQ5ZmViNjc1MGI5Nzk3NzgxODU0XCIsXCJwYWNrXCI6XCJsZXl1YW5cIn0ifQ.IHJjnwoi50LPAPjuqNffayYTOwX09ppATwlSDEncvOA",
    appVersionCode: 2490000
  };
  sessionStorage.setItem("baseParams", JSON.stringify(baseParams || paramsObj));
  const userInfo = await getUserInfoVal();
  user.value.icon = userInfo?.avatar || "";
  user.value.name = userInfo?.nickname;
  if (sessionStorage.getItem("detailFrom") && sessionStorage.getItem("detailFrom") === "main") {
    isShowOrderList.value = true;
  }
  const { onSuccess } = useRequest(()=>{return sureMember()})
  onSuccess((res)=>{
    const _data = res?.data?.data[0];
    if (_data?.status === 1) {
      isMember.value = true;
      if (_data?.endTime === 4102416000) {
        memberDesc.value = "永久";
      } else {
        memberDesc.value = `有效期至
              ${new Date(_data?.endTime * 1000)
          .toLocaleDateString("zh")
          .replace(/\//g, ".")}`;
      }
    } else if (_data?.status === 2) {
      memberDesc.value = "已过期";
    } else {
      memberDesc.value = "你还不是VIP会员";
    }
  })

  const { onSuccess:successFun } = useRequest(()=>{return getLecionBalance()})
  successFun((res)=>{
    if (res?.data?.data?.leCoinNum) {
      lecoinBalance.value = res?.data?.data?.leCoinNum;
    }
  })

});
</script>
<style scoped lang="scss">
.main {
  height: calc(100vh - 2.4rem - 1.6rem);
  transform: translateY(-1.6rem);

  .header {
    height: 12.44rem;
    background: url(/business/assets/imgs/minebg.webp);
    background-size: 100% 100%;
    padding-top: 1.6rem;

    .header-title {
      height: 2.5rem;
      display: flex;
      justify-content: space-around;
      align-items: center;

      .title {
        width: 3rem;
        font-weight: 600;
        font-size: 0.72rem;
        text-align: center;
        color: #fff;
      }
    }

    .back-icon {
      width: 1.067rem;
      height: 2.5rem;
      position: absolute;
      margin-left: 0.7rem;

      .back-img {
        margin-top: 1.25rem;
        transform: translateY(-50%);
      }
    }

    .user {
      height: 3.1rem;
      margin: 0.9rem 0;
      font-size: 0.54rem;
      color: rgba(255, 255, 255, 0.6);
      display: flex;
      align-items: center;

      img {
        height: 3.1rem;
        width: 3.1rem;
        border-radius: 50%;
        overflow: hidden;
        margin: 0 0.53rem 0 0.71rem;
      }

      .user-name {
        color: #fff;
        font-size: 0.71rem;
        font-weight: 500;
      }

      .user-desc {
        margin: 0.1rem 0;
      }
    }
  }

  .member-box {
    width: 14.5rem;
    height: 5.2rem;
    margin: -3.8rem auto 0 auto;
    background: #fff;
    border-radius: 0.5rem;

    .member-header {
      height: 2.13rem;
      border-radius: 0.5rem 0.5rem 0 0;
      background: #2b2835;
      color: #ffce3b;
      font-size: 0.43rem;
      display: flex;
      align-items: center;
      justify-content: space-between;

      span {
        height: 0.8rem;
        line-height: 0.8rem;
      }

      img {
        width: 0.8rem;
        height: 0.8rem;
        display: inline;
        margin: 0 0.47rem 0 0.64rem;
      }

      .btn {
        width: 3rem;
        height: 1.06rem;
        background: #ffce3b;
        color: #000;
        text-align: center;
        line-height: 1.06rem;
        border-radius: 0.5rem;
        font-size: 0.54rem;
        font-weight: 600;
        margin-right: 0.64rem;
      }
    }

    .member-footer {
      height: 2.5rem;
      margin-top: 0.25rem;
      color: rgba(0, 0, 0, 0.6);
      font-size: 0.54rem;
      display: flex;
      justify-content: space-around;

      img {
        height: 1.06rem;
        width: 1.06rem;
        margin-bottom: 0.34rem;
      }

      .member-footer-item {
        width: 7.25rem;
        display: flex;
        flex-direction: column;
        align-items: center;
      }
    }
  }

  .exchange-list {
    width: 14.5rem;
    height: 1.95rem;
    border-radius: 0.5rem;
    margin: 0.36rem auto;
    background: #fff;
    font-size: 0.54rem;
    color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: space-between;
    align-items: center;

    .left {
      margin-left: 0.53rem;

      img {
        height: 1.06rem;
        width: 1.06rem;
        margin-right: 0.17rem;
        display: inline;
      }

      span {
        display: inline-block;
        height: 1.95rem;
        line-height: 1.95rem;
      }
    }

    img {
      height: 0.47rem;
      width: 0.47rem;
      margin-right: 0.53rem;
    }
  }
}
</style>
